import { Injectable } from '@angular/core';
import * as localForage from 'localforage';

@Injectable()
export class LocalStorageService {

    getItem(key: string, callback: any): void {
        if (!localForage) {
            return;
        }

        localForage.getItem(key, callback);
    }

    getItemAsync(key: string): Promise<any> {
        if (!localForage) {
            return;
        }

        return localForage.getItem(key);
    }


    setItem(key, value, callback?: any): void {
        if (!localForage) {
            return;
        }

        if (value === null) {
            value = undefined;
        }

        localForage.setItem(key, value, callback);
    }

    setItemAsync(key, value): Promise<any> {
        if (!localForage) {
            return;
        }

        if (value === null) {
            value = undefined;
        }

        return localForage.setItem(key, value);
    }

    removeItem(key, callback?: any): void {
        if (!localForage) {
            return;
        }

        localForage.removeItem(key, callback);
    }

    removeItemAsync(key): Promise<any> {
        if (!localForage) {
            return;
        }

        return localForage.removeItem(key);
    }
    clearAllStorageAndCookies(){
        localForage.clear();
        sessionStorage.clear();
        document.cookie.split(";").forEach(function (cookie) {
            document.cookie = cookie
                .split("=")[0]
                .trim() +
                "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
        });
    }
}
